<ng-template #custLabel let-item="item">
    <div class="radio-button-label">
        <div class="title-container">
            <div>
                @if (!item.veg) {
                    <img src="{{ DEPLOY_URL }}/assets/images/non-veg.svg" class="veg-nonveg-icon" alt="NonVeg" />
                }
                @if (item.veg) {
                    <img src="{{ DEPLOY_URL }}/assets/images/veg.svg" class="veg-nonveg-icon" alt="Veg" />
                }
            </div>
            <div class="title">
                <span class="label">{{ item.label }}</span>
                <span class="description">{{ item.description }}</span>
            </div>
        </div>
        <div class="price-container">
            <span>+ </span>
            @if (item.marked_price > item.price) {
                <span class="cust_strikethrough_text">&#8377; {{ item.marked_price }}</span>
            }
            <span class="rupee"> &#8377; {{ item.price }}</span>
        </div>
    </div>
</ng-template>

<div class="group-customization-container">
    <div mat-dialog-title class="group-customization">
        <div class="close-icon" (click)="close()" role="button" tabindex="0" *appFeatureToggle="'desktop'">
            <img style="height: 25px" src="{{ DEPLOY_URL }}/assets/images/cross.svg" alt="cross" />
        </div>
        <div class="customization-heading">
            <div (click)="close()" role="button" tabindex="0" *appFeatureToggle="'mobile'">
                <mat-icon aria-hidden="true">keyboard_backspace</mat-icon>
            </div>
            <div class="label-container">
                <span class="heading-label">
                    {{ product.label }}
                </span>
                <span class="heading-sublabel">
                    {{ product.subcategory_name }}
                </span>
            </div>
        </div>
        <div class="scrolling-wrapper" #scrollContainer>
            @for (group of customizationGroupIds; track group) {
                <div #scrollContent>
                    <div
                        class="card"
                        [ngClass]="[
                            group === activeGroupId ? 'active' : selectedCustomization[group].valid ? 'completed' : 'pending',
                            bgInfo[group] !== undefined ? 'free-group' : ''
                        ]"
                        (click)="onGroupChange(group)"
                        role="button"
                        tabindex="0">
                        @if (bgInfo[group] !== undefined) {
                            <div>
                                <dotlottie-player autoplay="true" loop="true" class="lottie-container" src="{{ lottieUrl }}">
                                </dotlottie-player>
                            </div>
                        }
                        @if (bgInfo[group] !== undefined) {
                            <span class="free-badge">{{ bgInfo[group].tag_label }}</span>
                        }
                        <ng-template #freeText let-productId="activeGroupId"> </ng-template>
                        @if (!selectedCustomization[group].valid) {
                            <div class="card-image">
                                <span>+</span>
                            </div>
                        }
                        @if (selectedCustomization[group].valid && ct_groups && ct_groups[group]) {
                            <div class="card-image">
                                @if (bgInfo[group] === undefined) {
                                    <img
                                        class="group-image"
                                        appDeferImageLoad
                                        [imageSrc]="groupBaseIcon + '/' + ct_groups[group].id"
                                        [defaultImage]="'/assets/images/placeholder-icon.svg'"
                                        alt="add" />
                                }
                                @if (bgInfo[group] !== undefined) {
                                    <img
                                        class="group-image"
                                        appDeferImageLoad
                                        [imageSrc]="DEPLOY_URL + '/assets/images/confetti.svg'"
                                        [defaultImage]="'/assets/images/placeholder-icon.svg'"
                                        alt="icon" />
                                }
                            </div>
                        }
                        @if (selectedCustomization[group].label) {
                            <div class="card-label">
                                <span>{{ selectedCustomization[group].label }}</span>
                            </div>
                        }
                    </div>
                    @if (group === activeGroupId) {
                        <div class="card-underline"></div>
                    }
                </div>
            }
        </div>
    </div>
    <mat-dialog-content>
        @if (product.oft) {
            <div class="offer-text">
                <span>
                    {{ product.oft }}
                </span>
            </div>
        }
        @if (customizationList.get(activeGroupId)) {
            <div #customizationContainer class="customization-list">
                @for (customization of customizationList.get(activeGroupId); track customization) {
                    <div class="customization-list-container">
                        <div class="customization-list-title">
                            <div>
                                <h2>{{ customization.label }}</h2>
                            </div>
                            <div class="filter-buttons">
                                @for (filter of customization.filter_opts; track filter) {
                                    <button
                                        mat-button
                                        (click)="filterChange(filter, customization.id)"
                                        [ngClass]="[filteredCustomizations[customization.id].filter === filter ? 'active' : '']"
                                        mat-flat-button>
                                        {{ filter }}
                                    </button>
                                }
                            </div>
                        </div>
                        @if (customization.min === customization.max && customization.max === 1) {
                            <div>
                                <mat-radio-group style="display: flex; flex-direction: column; gap: 6px">
                                    @for (item of filteredCustomizations[customization.id].customizations; track item) {
                                        <mat-radio-button
                                            type="radio"
                                            color="primary"
                                            [disableRipple]="true"
                                            [value]="item"
                                            (change)="toggleProductSize($event, customization)"
                                            [checked]="isSelected(customization.id, item.id)">
                                            <ng-container *ngTemplateOutlet="custLabel; context: { item: item }"></ng-container>
                                        </mat-radio-button>
                                    }
                                </mat-radio-group>
                            </div>
                        } @else {
                            @for (item of filteredCustomizations[customization.id].customizations; track item) {
                                <mat-checkbox
                                    style="width: 100%"
                                    type="checkbox"
                                    color="primary"
                                    [value]="item"
                                    (change)="toggleProductSize($event, customization)"
                                    [checked]="isSelected(customization.id, item.id)"
                                    [disableRipple]="true">
                                    <ng-container *ngTemplateOutlet="custLabel; context: { item: item }"></ng-container>
                                </mat-checkbox>
                            }
                        }
                    </div>
                }
            </div>
        }
    </mat-dialog-content>
    <mat-dialog-actions *appFeatureToggle="'desktop'">
        <ng-container *ngTemplateOutlet="actionButton"></ng-container>
    </mat-dialog-actions>
</div>

<ng-container *appFeatureToggle="'mobile'">
    <ng-container *ngTemplateOutlet="actionButton"></ng-container>
</ng-container>

<ng-template #actionButton>
    @if (bottomStrip.length) {
        <div class="bottom-strip-group-cust">
            <img src="{{ DEPLOY_URL }}/assets/images/confetti.svg" alt="confetti" />
            <span
                ><b>{{ bottomStrip[0] + ': ' }}</b
                >{{ bottomStrip[1] }}</span
            >
        </div>
    }
    <div class="button-container">
        <div class="action-label">
            <span class="label">Items Added</span>
            <span class="number">{{ buttonCount['selected'] }}/{{ buttonCount['total'] }}</span>
        </div>
        <button btn-primary (click)="submit()">
            <div>
                <div>
                    <span>{{ buttonCount['total'] - buttonCount['selected'] === 0 ? 'Add to Cart' : 'Next' }}</span>
                    @if (buttonCount['total'] - buttonCount['selected'] !== 0) {
                        <mat-icon aria-hidden="true">play_arrow</mat-icon>
                    }
                </div>
                <span>&#8377;{{ totalPrice + defaultPrice }}</span>
            </div>
        </button>
    </div>
</ng-template>
